import axios from 'axios'
import { showSuccess, showError } from '../../index.js'
import router from '@/router'
import DOMPurify from 'dompurify'

export default {
  namespaced: true,
  state () {
    return {
      admissions: [],
      frontendAdmissions: [],
      admissionDetails: [],
      homeAdmissions: [],
      blankAdmissionData: {
        id: 0,
        title: '',
        summary: '',
        description: 'Typing description ...',
        subMenuId: 0
      },
      admissionLabelData: [
        {
          title: 'Đăng ký tuyển sinh',
          sub1: 'Sẵn sàng bắt đầu hành trình cùng chúng tôi!',
          sub2: 'Hãy hoàn thành biểu mẫu dưới đây.',
          selfInfo: 'Thông tin cá nhân',
          name: 'Họ tên',
          gender: 'Giới tính',
          male: 'Nam',
          female: 'Nữ',
          birthday: 'Ngày sinh',
          age: 'Tuổi',
          birthPlace: 'Nơi sinh',
          citizenIdentificationCard: 'Căn cước công dân',
          dateOfIssue: 'Ngày cấp',
          placeOfIssue: 'Nơi cấp',
          permanentRes: 'Hộ khẩu thường trú',
          englishCertificate: 'Chứng chỉ tiếng Anh',
          contactAddress: 'Địa chỉ liên lạc',
          phoneNum: 'Số điện thoại',
          email: 'Email',
          eduLevel: 'Trình độ văn hóa',
          expertLevel: 'Trình độ chuyên môn',
          englishScore: 'Điểm tiếng anh',
          expiredDate: 'Ngày hết hạn',
          familyInfo: 'Thông tin gia đình',
          fatherName: 'Họ tên cha',
          motherName: 'Họ tên mẹ',
          familyBirthYear: 'Năm sinh',
          parentPhoneNum: 'Số điện thoại Bố (Mẹ)',
          workplace: 'Nơi công tác',
          trainingPlan: 'Kế hoạch đào tạo',
          startDate: 'Thời gian dự kiến đi học',
          graduatedDate: 'Thời gian dự kiến tốt nghiệp',
          school: 'Tại trường',
          attachments: 'Tài liệu đính kèm',
          resume: 'Sơ yếu lý lịch',
          medicalExamination: 'Phiếu khám sức khỏe',
          reportCard: 'Phiếu điểm tiếng anh',
          judicialRecord: 'Lý lịch tư pháp',
          file1: 'Đơn xin dự tuyển',
          file2: 'Bản khai lý lịch',
          file3: 'Giấy khai sinh',
          file4: 'Bằng Tốt nghiệp',
          file5: 'Phiếu điểm tiếng Anh',
          file6: 'Hộ chiếu và CCCD Học viên',
          file7: 'CCCD người bảo lãnh',
          file8: 'Ảnh 4x6 và ảnh 3x4',
          file9: 'Phiếu khám sức khỏe',
          file10: 'Lý lịch tư pháp',
          tip1: '',
          tip2: 'Có xác nhận của chính quyền địa phương',
          tip3: 'Bản sao công chứng',
          tip4: 'Bản sao công chứng (cấp 3 trở lên)',
          tip5: 'Bản sao công chứng',
          tip6: 'Bản sao công chứng',
          tip7: 'Bản sao công chứng',
          tip8: 'Nền trắng',
          tip9: 'Do Trung tâm Y tế HK hoặc Viện Y học Phòng Không - Không Quân cấp',
          tip10: 'Số 2',
          sample: 'Mẫu',
          submit: 'Đăng ký'
        },
        {
          title: 'Admission Registration',
          sub1: 'Ready to start the journey with us!',
          sub2: 'Please complete the form below.',
          selfInfo: 'Personal Information',
          name: 'Full Name',
          gender: 'Gender',
          male: 'Male',
          female: 'Female',
          birthday: 'Date of birth',
          age: 'Age',
          birthPlace: 'Birth place',
          citizenIdentificationCard: 'Citizen identification card',
          dateOfIssue: 'Date of issue',
          placeOfIssue: 'Place of issue',
          permanentRes: 'Permanent Address',
          englishCertificate: 'English Certificate',
          contactAddress: 'Contact Address',
          phoneNum: 'Phone Number',
          email: 'Email',
          eduLevel: 'Education Level',
          expertLevel: 'Professional Qualification',
          englishScore: 'English Score',
          expiredDate: 'Expiration Date',
          familyInfo: 'Family Information',
          fatherName: "Father's full name",
          motherName: "Mother's full name",
          familyBirthYear: 'Birth year',
          parentPhoneNum: "Father's (Mother's) phone number",
          workplace: 'Workplace',
          trainingPlan: 'Training Plan',
          startDate: 'Planned Start Date',
          graduatedDate: 'Planned Graduation Date',
          school: 'At School',
          attachments: 'Attachments',
          resume: 'Resume',
          medicalExamination: 'Medical Examination Report',
          reportCard: 'English Report Card',
          judicialRecord: 'Judicial Record',
          file1: 'Application Form',
          file2: 'Personal Resume',
          file3: 'Birth Certificate',
          file4: 'Graduation Diploma',
          file5: 'English Score Report',
          file6: 'Trainee Passport and Citizen ID',
          file7: 'Guarantor Citizen ID',
          file8: '4x6 and 3x4 Photos',
          file9: 'Health Examination Report',
          file10: 'Judicial Record',
          tip1: '',
          tip2: 'Certified by the local government',
          tip3: 'Notarized copy',
          tip4: 'Notarized copy (high school or higher)',
          tip5: 'Notarized copy',
          tip6: 'Notarized copy',
          tip7: 'Notarized copy',
          tip8: 'White background',
          tip9: 'Issued by the HK Medical Center or Air Defense Aviation Medical Institute',
          tip10: 'No. 2',
          sample: 'Sample',
          submit: 'Submit'
        }
      ],
      applications: [],
      applicationFiles: []
      // vnAdmissionFormData: [
      //   {
      //     title: 'Đăng ký tuyển sinh',
      //     sub1: 'Sẵn sàng bắt đầu hành trình cùng chúng tôi!',
      //     sub2: 'Hãy hoàn thành biểu mẫu dưới đây.',
      //     name: 'Tên',
      //     phName: 'Họ tên',
      //     birthday: 'Ngày sinh',
      //     phDate: 'Ngày',
      //     phMonth: 'Tháng',
      //     phYear: 'Năm',
      //     cccd: 'Số CCCD',
      //     address: 'Địa chỉ',
      //     phAddress: 'Số nhà, tên đường, quận/huyện, thành phố',
      //     files: 'Hồ sơ và giấy chứng nhận',
      //     submit: 'Đăng ký',
      //     errName: 'Tên không được để trống',
      //     errBirth: 'Ngày sinh không được để trống và phải hợp lệ',
      //     errCccd: 'Số CCCD không hợp lệ',
      //     errAddress: 'Địa chỉ không thể để trống'
      //   },
      //   {
      //     title: 'Application Form',
      //     sub1: 'Ready to start your journey with us!',
      //     sub2: 'Complete the form below.',
      //     name: 'Name',
      //     phName: 'Full name',
      //     birthday: 'Date of birth',
      //     phDate: 'Date',
      //     phMonth: 'Month',
      //     phYear: 'Year',
      //     cccd: 'Citizen identification card number',
      //     address: 'Address',
      //     phAddress: 'Street address, district, city',
      //     files: 'Resume and certifications',
      //     submit: 'Submit',
      //     errName: 'Name must not be empty',
      //     errBirth: 'Birthday must not be empty or invalid',
      //     errCccd: 'CIC number is invalid',
      //     errAddress: 'Address must not be empty'
      //   }
      // ]
    }
  },
  getters: {
    finalFormData (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnAdmissionFormData[0]
      } else {
        return state.vnAdmissionFormData[1]
      }
    },
    labelFormData (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.admissionLabelData[0]
      } else {
        return state.admissionLabelData[1]
      }
    },
    getFrontendAdmissions (state, getters, rootState) {
      return state.frontendAdmissions.filter(item => item.lang === rootState.lang)
    },
    findAdmission: (state, getters, rootState) => (url) => {
      if (rootState.lang === 'vn') {
        const data = state.admissions.filter(item => item.lang === 'vn')
        return data.find(item => item.url === url)
      } else {
        const data = state.admissions.filter(item => item.lang === 'en')
        return data.find(item => item.url === url)
      }
    },
    backendAdmissions (state) {
      return state.admissions.filter(item => item.lang === 'vn')
    },
    vnBackendAdmissionTab: (state) => (url) => {
      const data = state.admissions.find(item => item.url === url && item.lang === 'vn')
      if (!data) {
        return state.blankAdmissionData
      }
      return data
    },
    enBackendAdmissionTab: (state) => (url) => {
      const data = state.admissions.find(item => item.url === url && item.lang === 'en')
      if (!data) {
        return state.blankAdmissionData
      }
      return data
    },
    topAdmissions (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.homeAdmissions.filter(item => item.lang === 'vn' && item.hidden === false)
      } else {
        return state.homeAdmissions.filter(item => item.lang === 'en' && item.hidden === false)
      }
    },
    // searchSectionAdmissions (state, getters, rootState) {
    //   return state.frontendAdmissions.filter(item => item.lang === rootState.lang)
    // },
    backendAppications (state) {
      return state.applications
    },
    getAppicationIds (state) {
      return state.applications.map(item => item.id).reverse()
    },
    backendAppicationFiles (state) {
      return state.applicationFiles
    },
    getAdmissionsDetail (state, getters, rootState) {
      return state.admissionDetails.find(item => item.lang === rootState.lang)
    }
  },
  mutations: {
    setAdmissions (state, payload) {
      state.admissions = payload
    },
    setApplications (state, payload) {
      state.applications = payload
    },
    setApplicationFiles (state, payload) {
      state.applicationFiles = payload
    },
    setHomeAdmissions (state, payload) {
      state.homeAdmissions = payload
    },
    setFrontendAdmissions (state, payload) {
      state.frontendAdmissions = payload
    },
    setAdmissionsDetail (state, payload) {
      state.admissionDetails = payload
    }
  },
  actions: {
    async getHomeAdmissionsData (context) {
      await axios.get(context.rootState.API_Url + 'Admissions/GetHomeAdmissions').then((response) => {
        const responseData = response.data
        context.commit('setHomeAdmissions', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getAdmissionsByFilter (context, { filterQuery }) {
      await axios.get(context.rootState.API_Url + 'Admissions/GetAdmissionsByFilter', {
        params: {
          filterQuery: filterQuery,
          lang: context.rootState.lang
        }
      }).then((response) => {
        const responseData = response.data
        context.commit('setFrontendAdmissions', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getAdmissionsDetailByUrl (context, payload) {
      await axios.get(context.rootState.API_Url + `Admissions/${payload}`).then((response) => {
        const responseData = response.data
        context.commit('setAdmissionsDetail', responseData)
      }).catch(() => {
        router.push('/no-info')
      })
    },
    async getTotalAdmissions (context) {
      /* eslint-disable */
      let totalForPage = 1

      await axios.get(context.rootState.API_Url + 'Admissions/GetTotalItems').then((response) => {
        totalForPage = Math.ceil(response.data / 6)
      }).catch((error) => {
        console.error('There was an error!', error)
      })

      return totalForPage
    },
    async getAdmissionsByPage (context, { pageNumber = 1 }) {
      await axios.get(context.rootState.API_Url + 'Admissions/GetAdmissionsByPage', {
        params: {
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data
        context.commit('setFrontendAdmissions', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getEnAdmissionAdminData (context, { url }) {
      /* eslint-disable */
      let data = null

      // await axios.get(context.rootState.API_Url + 'Admissions/GetEngData', {
      await context.rootState.authAxios.get('/Admissions/GetEngData', {
        params: {
          url: url
        }
      }).then((response) => {
        data = response.data
        data.description = DOMPurify.sanitize(data.description)
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })

      if (!data) {
        return context.state.blankAdmissionData
      }
      return data 
    },
    async getAdmissionByPageWithFilter (context, { filteredTerm, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      // await axios.get(context.rootState.API_Url + 'Admissions/GetAdmissionByPageWithFilterAdmin', {
      await context.rootState.authAxios.get('/Admissions/GetAdmissionByPageWithFilterAdmin', {
        params: {
          filteredTerm: filteredTerm,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData.map(item => ({
          ...item,
          description: DOMPurify.sanitize(item.description)
        }))
        totalForPage = Math.ceil(response.data.totalRecords / 6)
        context.commit('setAdmissions', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    // async getAdmissionData (context) {
    //   await axios.get(context.rootState.API_Url + 'Admissions').then((response) => {
    //     const responseData = response.data
    //     context.commit('setAdmissions', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // },
    async postAdmission (context, payload) {
      await context.rootState.authAxios.post('/Admissions/', {
        title: payload.title,
        img: payload.img,
        url: payload.url,
        summary: payload.summary,
        description: payload.description,
        subMenuId: payload.subMenuId,
        hidden: payload.hidden,
        lang: payload.lang
      })
    },
    async updateAdmission (context, payload) {
      await context.rootState.authAxios.put(`/Admissions/${payload.id}`, {
        title: payload.title,
        img: payload.img,
        url: payload.url,
        summary: payload.summary,
        description: payload.description,
        subMenuId: payload.subMenuId,
        hidden: payload.hidden,
        lang: payload.lang
      })
    },
    async deleteAdmission (context, payload) {
      await context.rootState.authAxios.delete(`/Admissions/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async changeStatusAdmission (context, payload) {
      await context.rootState.authAxios.put(`/Admissions/ChangeStatus/${payload}`
      ).then(() => {
        showSuccess('Change status successfully')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    // Applications
    // async getApplicationData (context) {
    //   await axios.get(context.rootState.API_Url + 'Applications/').then((response) => {
    //     const responseData = response.data
    //     context.commit('setApplications', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // },
    async getApplicationsByPageWithFilter (context, { filteredTerm, filteredStartDate, filteredEndDate,  pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      await context.rootState.authAxios.get('/Applications/GetApplicationByPageWithFilterAdmin', {
        params: {
          filteredTerm: filteredTerm,
          filteredStartDate: filteredStartDate,
          filteredEndDate: filteredEndDate,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData
        totalForPage = Math.ceil(response.data.totalRecords / 10)  
        context.commit('setApplications', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    async getApplicationDataWithFilter (context, { filteredTerm }) {
      await context.rootState.authAxios.get('/Applications/FilteredData', {
        params: {
          filteredTerm: filteredTerm,
        }
      }).then((response) => {
        const responseData = response.data
        context.commit('setApplications', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })
    },
    async getApplicationFilesData (context, payload) {
      await context.rootState.authAxios.get(`ApplicationFiles/${payload}`).then((response) => {
        const responseData = response.data
        context.commit('setApplicationFiles', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async updateApplication (context, payload) {
      await context.rootState.authAxios.put(`Applications/${payload.id}`, payload.data)
    },
    async getFilesChecked (context, { ids }) {
      let fileData = null
      // await axios.get(context.rootState.API_Url + 'ApplicationFiles/CheckFiles'
      await context.rootState.authAxios.get('ApplicationFiles/CheckFiles', {
        params: {
          applicationIds: ids.join(','),
        }
      }).then((response) => {
        fileData = response.data
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn khi check files')
      })

      return fileData
    },
    async deleteApplication (context, payload) {
      await context.rootState.authAxios.delete(`Applications/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async exportExcel (context, { filteredTerm, filteredStartDate, filteredEndDate}) {
      await context.rootState.authAxios.get('/Applications/ApplicationReports', { 
          responseType: 'blob',
          params: {
            filteredTerm: filteredTerm,
            filteredStartDate: filteredStartDate,
            filteredEndDate: filteredEndDate
          } 
        })
        .then((res) => {
          const filename = res.headers['content-disposition']
            .split(';')
            // eslint-disable-next-line
            .find(function (el) {
              if (el.includes('filename=')) return el
            })
            .replace('filename=', '')
            .trim()
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.ms-excel;charset=utf-8'
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename) // or any other extension
          document.body.appendChild(link)
          link.click()

          // Cleanup
          link.remove()
          window.URL.revokeObjectURL(url)
        }).catch((error) => {
          if (error.response.data.error_message) {
            showError(error.response.data.error_message)
          } else {
            showError('Đã xảy ra lỗi không mong muốn')
          }
        })
    },
    async exportPerExcel (context, { appId }) {
      try {
        const res = await context.rootState.authAxios.get('/Applications/ApplicationPerReport', {
          responseType: 'blob',
          params: {
            appId: appId
          }
        })

        const excelFile = new File([res.data], 'Report.xlsx', {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // const excelBlob = new Blob([res.data], {
        //   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        // })
    
        return excelFile
      } catch (error) {
        if (error.response?.data?.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn !!!')
        }
        return null
      }
    }
  }
}
